import gql from 'graphql-tag'

export const myEventsQuery = gql`
    query getMyEvents($first: Int) {
        myEvents(first: $first) {
            edges {
                node{
                    id
                    name
                    slug
                    startDate
                    endDate
                }
            }
        }
        currentUser {
            id
            isSuperUser
        }
    }
`

export const myOrganizationsQuery = gql`
    query getMyOrganizations {
        myOrganizations {
            edges {
                node {
                    id
                    name
                    language
                }
            }
        }
    }
`

gql`
    fragment myEvents on EventType {
        id
        name
        slug
        startDate
        endDate
    }
`
